import React from 'react';
import cloneDeep from 'lodash/cloneDeep';
import { Footer as SharedFooter } from '@spotify-internal/masthead-react';
import { Footer as S4XFooter } from '@spotify-internal/s4x-masthead';

import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';
import { Vertical, MastheadVariants } from 'utils/vertical';
import { useMastheadData } from 'providers/MastheadProvider';
import { TurnkeyFooter } from 'components/Masthead/Footer';

export const Footer = () => {
  const { footer, turnkeyFooter, useTurnkeyMasthead } = useMastheadData();

  const {
    verticalConfig: { verticalName, features },
    market: { locale, preferredDir },
  } = useServerSideConstants();

  const useTurnkeyFooter =
    features.configureMasthead?.footer === MastheadVariants.TURNKEY ||
    (useTurnkeyMasthead && !features.configureMasthead);

  if (features.configureMasthead?.footer === MastheadVariants.S4A) {
    return <S4XFooter />;
  }

  if (useTurnkeyFooter && turnkeyFooter) {
    return <TurnkeyFooter data={turnkeyFooter} />;
  }

  if (!footer) return null;

  const topLinkGroups = cloneDeep(footer.topLinkGroups);

  // A custom Contact Us link is added for the en-US market when using the consumer vertical
  if (topLinkGroups?.length && verticalName === Vertical.CONSUMER && locale === 'en-US') {
    topLinkGroups[topLinkGroups.length - 1].links?.push({
      title: 'Contact Spotify',
      href: 'https://support.spotify.com/article/contact-us/?in_footer',
    });
  }

  return (
    <div dir={preferredDir}>
      <SharedFooter {...footer} topLinkGroups={topLinkGroups} />
    </div>
  );
};
